// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 1H20V5H18V3H6V17H18V15H20V23H4V1ZM13.0039 19H11V21.0039H13.0039V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 7H13V9H24V7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 11H13V13H21V11Z"}}]};

const MobileListFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mobile-list-filled',
    ref,
    icon: element,
  },
));

MobileListFilledIcon.displayName = 'MobileListFilledIcon';

export default MobileListFilledIcon;
